/* ROOTINE back-in-stock: switches the buy area per variant and submits the request popup. */
(function () {
  'use strict';

  var PHONE_RE = /^05\d{8}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function normalizePhone(value) {
    var digits = String(value || '').replace(/[\s\-().]/g, '');
    if (digits.charAt(0) === '+') digits = digits.slice(1);
    if (digits.indexOf('972') === 0) digits = '0' + digits.slice(3);
    return digits;
  }

  function init(root) {
    if (!root || root.dataset.rtBisReady === 'true') return;
    root.dataset.rtBisReady = 'true';

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-rt-bis-variants]').textContent);
    } catch (e) { variants = []; }

    var sectionId = root.dataset.section;
    var productTitle = root.dataset.productTitle || '';
    var handle = root.dataset.productHandle || '';
    var defaultOnly = root.dataset.defaultOnly === 'true';
    var modal = root.querySelector('[data-rt-bis-modal]');
    var form = modal ? modal.querySelector('form') : null;
    var statusEl = root.querySelector('[data-rt-bis-status]');
    var altsWrap = root.querySelector('[data-rt-bis-alts]');
    var altsList = root.querySelector('[data-rt-bis-alts-list]');
    var tagsInput = root.querySelector('[data-rt-bis-tags]');
    var variantNameEl = root.querySelector('[data-rt-bis-variant-name]');
    var fieldsEl = root.querySelector('[data-rt-bis-fields]');
    var successEl = root.querySelector('[data-rt-bis-success]');
    var successText = root.querySelector('[data-rt-bis-success-text]');
    var alertEl = root.querySelector('[data-rt-bis-alert]');
    var lastFocus = null;
    var current = null;

    // Move the popup to <body> so theme transforms/overflow can't clip it.
    if (modal && modal.parentNode !== document.body) {
      var stale = document.querySelectorAll('body > [data-rt-bis-modal]');
      for (var k = 0; k < stale.length; k++) if (stale[k].id === modal.id) stale[k].remove();
      document.body.appendChild(modal);
    }
    if (form) form.noValidate = true;

    function variantInput() {
      var f = document.getElementById('product-form-' + sectionId);
      return f ? f.querySelector('input[name="id"]') : null;
    }
    function currentVariantId() {
      var input = variantInput();
      var id = input && input.value ? input.value : '';
      if (!id) {
        var m = window.location.search.match(/[?&]variant=(\d+)/);
        if (m) id = m[1];
      }
      return id ? Number(id) : null;
    }
    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }
    function label(v) {
      if (!v || defaultOnly) return productTitle;
      return productTitle + ' – ' + v.title;
    }

    function renderAlts(v) {
      if (!altsList) return 0;
      altsList.innerHTML = '';
      var count = 0;
      variants.forEach(function (o) {
        if (!o.available || (v && o.id === v.id)) return;
        count++;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'rt-bis__alt';
        a.href = root.dataset.productUrl + '?variant=' + o.id;
        a.setAttribute('data-variant-id', o.id);
        a.textContent = o.title;
        li.appendChild(a);
        altsList.appendChild(li);
      });
      if (altsWrap) altsWrap.hidden = count === 0;
      return count;
    }

    function update(force) {
      var id = currentVariantId();
      var v = findVariant(id) || (variants.length ? variants[0] : null);
      if (!force && current && v && current.id === v.id) return;
      current = v;
      var oos = !!v && v.available === false;
      root.dataset.oos = oos ? 'true' : 'false';
      document.body.classList.toggle('rt-bis-oos', oos);
      if (!v) return;
      var others = renderAlts(v);
      if (statusEl) statusEl.textContent = others > 0 ? 'הכד הזה אזל זמנית' : 'המוצר הזה אזל זמנית';
      if (variantNameEl) variantNameEl.textContent = v.title;
      if (tagsInput) tagsInput.value = 'back-in-stock, bis-variant-' + v.id + ', bis-product-' + handle;
    }

    function selectVariant(id) {
      var v = findVariant(id);
      if (!v) return false;
      var picker = document.getElementById('variant-selects-' + sectionId);
      if (!picker) return false;
      var ok = true;
      v.options.forEach(function (value) {
        var radios = picker.querySelectorAll('input[type="radio"]');
        var hit = null;
        for (var i = 0; i < radios.length; i++) if (radios[i].value === value) { hit = radios[i]; break; }
        if (hit) {
          if (!hit.checked) hit.click();
          return;
        }
        var selects = picker.querySelectorAll('select');
        for (var j = 0; j < selects.length; j++) {
          var opt = Array.prototype.find.call(selects[j].options, function (o) { return o.value === value; });
          if (opt) {
            selects[j].value = value;
            selects[j].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
        ok = false;
      });
      if (ok) window.setTimeout(function () { update(true); }, 300);
      return ok;
    }

    // Sticky add-to-cart bar: add our own button next to the theme's (CSS shows one or the other).
    function addStickyButtons() {
      document.querySelectorAll('sticky-atc .sticky-atc__button').forEach(function (wrap) {
        if (wrap.querySelector('.rt-bis-sticky-btn')) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rt-bis-sticky-btn sticky-atc__add_button button';
        b.textContent = 'עדכנו אותי ברגע שהמלאי חוזר';
        b.addEventListener('click', function (e) { e.preventDefault(); openModal(b); });
        wrap.appendChild(b);
      });
    }

    function openModal(trigger) {
      if (!modal) return;
      lastFocus = trigger || document.activeElement;
      if (successEl && !successEl.hidden && fieldsEl && fieldsEl.hidden && !fieldsEl.hasAttribute('data-posted')) {
        successEl.hidden = true;
        fieldsEl.hidden = false;
      }
      modal.classList.add('is-open');
      document.body.classList.add('rt-bis-lock');
      var first = modal.querySelector('[data-rt-bis-name]') || modal.querySelector('input:not([type="hidden"])');
      var panel = modal.querySelector('.rt-bis-modal__panel');
      if (panel && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
      var desktop = window.matchMedia('(min-width: 750px)').matches;
      window.setTimeout(function () {
        if (desktop && first && fieldsEl && !fieldsEl.hidden) first.focus();
        else if (panel) panel.focus({ preventScroll: true });
      }, 50);
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('rt-bis-lock');
      if (window.location.hash && modal.querySelector(window.location.hash.replace(/[^#\w-]/g, ''))) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } else if (window.location.hash === '#' + modal.id) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function showAlert(msg, field) {
      if (!alertEl) return;
      alertEl.textContent = msg;
      alertEl.hidden = !msg;
      if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
    }

    function showSuccess(text) {
      if (fieldsEl) fieldsEl.hidden = true;
      if (successText) successText.textContent = text;
      if (successEl) successEl.hidden = false;
    }

    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-rt-bis-open]');
      if (open) { e.preventDefault(); openModal(open); return; }
      var alt = e.target.closest('.rt-bis__alt');
      if (alt) {
        var id = Number(alt.getAttribute('data-variant-id'));
        if (selectVariant(id)) e.preventDefault();
      }
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-rt-bis-close]')) { e.preventDefault(); closeModal(); }
      });
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(
          modal.querySelectorAll('a[href]:not([tabindex="-1"]), button, input:not([type="hidden"])'),
          function (el) { return el.offsetParent !== null && !el.disabled; }
        );
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var phone = form.querySelector('[data-rt-bis-phone]');
        var email = form.querySelector('[data-rt-bis-email]');
        form.querySelectorAll('[aria-invalid]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
        var phoneDigits = normalizePhone(phone ? phone.value : '');
        var emailValue = email ? email.value.trim() : '';
        if (!phoneDigits) { e.preventDefault(); return showAlert('נא להזין מספר טלפון נייד', phone); }
        if (!PHONE_RE.test(phoneDigits)) { e.preventDefault(); return showAlert('מספר הטלפון אינו תקין', phone); }
        if (!emailValue) { e.preventDefault(); return showAlert('נא להזין כתובת אימייל', email); }
        if (!EMAIL_RE.test(emailValue)) { e.preventDefault(); return showAlert('כתובת האימייל אינה תקינה', email); }
        showAlert('');

        var v = current || findVariant(currentVariantId());
        var tags = ['back-in-stock', 'bis-product-' + handle, 'bis-phone-' + phoneDigits];
        if (v) tags.splice(1, 0, 'bis-variant-' + v.id);
        if (tagsInput) tagsInput.value = tags.join(', ');
        if (phone) phone.value = '+972' + phoneDigits.slice(1);
        var doneText = 'מעולה! נעדכן אותך ברגע ש' + label(v) + ' חוזר למלאי.';
        try { sessionStorage.setItem('rt-bis-last', doneText); } catch (err) {}

        // Submit in the background so the page (and the 10% signup popup) is not reloaded into its success state.
        if (!window.fetch || !window.FormData) return; // native POST fallback
        e.preventDefault();
        var submit = form.querySelector('[data-rt-bis-submit]');
        if (submit) submit.setAttribute('aria-busy', 'true');
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow' })
          .then(function (res) {
            var url = res.url || '';
            if (/\/challenge/.test(url)) { form.submit(); return; }
            return res.text().then(function (html) {
              if (/customer_posted=true/.test(url) || /posted_successfully/.test(url)) return showSuccess(doneText);
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var f = doc.getElementById(form.id);
              if (f && f.querySelector('[data-rt-bis-server-error]')) return showAlert('משהו לא עבד. בדקו את הפרטים ונסו שוב.');
              if (f && f.querySelector('[data-rt-bis-success]:not([hidden])')) return showSuccess(doneText);
              showAlert('משהו לא עבד. נסו שוב בעוד רגע.');
            });
          })
          .catch(function () { showAlert('משהו לא עבד. נסו שוב בעוד רגע.'); })
          .then(function () { if (submit) submit.removeAttribute('aria-busy'); });
      });
    }

    // Returning from a native POST (no fetch / captcha): only react if the redirect targets our form.
    var posted = fieldsEl && fieldsEl.hasAttribute('data-posted');
    var ourHash = form && window.location.hash === '#' + form.id;
    if (posted && ourHash) {
      var saved = null;
      try { saved = sessionStorage.getItem('rt-bis-last'); } catch (err) {}
      showSuccess(saved || (successText ? successText.textContent : ''));
      openModal();
    } else if (posted) {
      // Another customer form (e.g. newsletter) posted: keep our form usable.
      fieldsEl.hidden = false;
      fieldsEl.removeAttribute('data-posted');
      if (successEl) successEl.hidden = true;
    }
    if (window.location.hash === '#' + (modal && modal.id)) openModal();

    addStickyButtons();
    update(true);

    // Follow the theme's variant changes.
    document.addEventListener('change', function () { window.setTimeout(update, 60); }, true);
    var input = variantInput();
    if (input && window.MutationObserver) {
      new MutationObserver(function () { update(); }).observe(input, { attributes: true, attributeFilter: ['value'] });
    }
    window.setInterval(function () { update(); addStickyButtons(); }, 700);
  }

  function initAll() { document.querySelectorAll('[data-rt-bis]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
